<template>
<div>
    <div class="comment-text ml-2">
        <p class="text-muted text-right">{{hit._source.date | localDateNoHour}}</p>
        <p>
            <strong>{{translate('messages.legislature')}}:</strong> <a target="_BLANK" :href="hit._source.legislature_link">{{hit._source.legislature}}</a>
        </p>
        <p>
            <strong>{{translate('messages.fiscal_year')}}:</strong> {{hit._source.fiscal_year}}
        </p>
        <p>
            <strong>{{translate('messages.period')}}:</strong> <a target="_BLANK" :href="hit._source.period_link">{{hit._source.period}}</a> (<i>{{hit._source.period_range}}</i>)
        </p>
        <strong>{{translate('messages.coincidences')}}:</strong>
        <div v-if="hit.hasOwnProperty('highlight')">
            <div v-for="(highlight, index) in hit.highlight.body" :key="'hit-highlight-'+hit._id+'.'+index">
                <strong>...</strong> <span v-html="highlight"></span> <strong>...</strong>
            </div>
        </div>
    </div>
    <div>
        <a class="btn btn-notiblue btn-sm m-1" target="_BLANK" :href="hit._source.link">{{translate('messages.go_to')}} {{translate('messages.chronicle')}}</a>
    </div>
</div>
</template>
 
<script>
export default {
    props: ['hit']
}
</script>